import { ChangeDetectorRef, Component, effect, EventEmitter, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Details } from 'src/interfaces/details.model';
import { Restaurant } from 'src/interfaces/restaurant.model';
import { MenuFooterDialogComponent } from '../menu-footer-dialog/menu-footer-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { ScrollService } from 'src/app/services/scroll.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-menu-footer',
    templateUrl: './menu-footer.component.html',
    styleUrls: ['./menu-footer.component.css'],
    standalone: false
})

export class MenuFooterComponent {
  constructor(
    private scrollService: ScrollService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.details = this.dataService.restaurant?.details || {
      title: '',
      inn: '',
      kpp: '',
      ogrn: '',
      address: ''
    };
    this.restaurant = this.dataService.restaurant || null;
    
    // Реакция на сигнал isListRendered
    effect(() => {
      this.isRendered = this.dataService.isListRendered();
      console.log(`MenuFooterComponent | effect | isRendered: ${this.isRendered}`);
      this.cdr.detectChanges();
    });
  }

  /// Политика конфиденциальности (legal.edim.app): сербская версия —
  /// сербскоязычным, остальным — английский перевод
  get policyUrl(): string {
    return (document.documentElement.lang || 'en').startsWith('sr')
      ? 'https://legal.edim.app/srb/privacy'
      : 'https://legal.edim.app/srb/en/privacy';
  }

  // @Output() footerRendered = new EventEmitter<void>();

  details: Details;
  restaurant: Restaurant | null = null;
  isRendered = false;
  agreement = true;

  toggleAgreement(): void {
    this.agreement = !this.agreement;
    this.dataService.agreement = this.agreement;
  }

  onContactsClicked(): void {
    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');

    this.scrollService.setScrollEnabled(false);
    const dialogRef = this.dialog.open(MenuFooterDialogComponent, sheetDialogConfig(this.details));

    dialogRef.afterClosed().subscribe(() => {
      this.scrollService.setScrollEnabled(true);

      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#f5f5ff');
    });
  }

  production(): boolean {
    return !this.dataService.restaurant?.demo;
  }
}